import { styles, variants, LabelTheme } from '../LabelStyles.css';
import { baseTheme } from './LabelBaseTheme.css';
import { multiVariantStyles } from './LabelVariants.css';

/*******************
 * Component Theme
 *******************/

const LabelRedwoodTheme: LabelTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { LabelRedwoodTheme };
